import React from 'react';

import { PublicLanguage } from '../../../pages/public/types';

interface LanguageToggleProps {
  language: PublicLanguage;
  onChange: (language: PublicLanguage) => void;
  label: string;
}

const getLangToggleClass = (isActive: boolean): string => {
  return isActive
    ? 'px-3 py-1 rounded-md text-sm font-semibold bg-blue-600 text-white'
    : 'px-3 py-1 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-100';
};

const LanguageToggle: React.FC<LanguageToggleProps> = ({ language, onChange, label }) => {
  return (
    <div
      className="flex items-center gap-2 border border-gray-200 rounded-lg p-1"
      aria-label={label}
    >
      <button
        type="button"
        className={getLangToggleClass(language === 'en')}
        onClick={() => onChange('en')}
      >
        EN
      </button>
      <button
        type="button"
        className={getLangToggleClass(language === 'es')}
        onClick={() => onChange('es')}
      >
        ES
      </button>
    </div>
  );
};

export default LanguageToggle;
